import React, { Component, lazy, Suspense } from "react";
import { HashRouter as Router, Switch, Route } from "react-router-dom";

// Components
import ReactGA from "react-ga";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GlobalLoader from "./components/Loader/GlobalLoader/GlobalLoader";
import { iAmLive } from "./api";

import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.slim.js";
import "bootstrap/dist/js/bootstrap.min.js";
import "c3/c3.css";
import "./App.scss";
import "./colorSchemes.scss";
// import createHistory from 'history/createBrowserHistory'

// const history = createHistory()
// history.listen((location, action) => {
// 	ReactGA.set({ page: location.pathname });
// 	ReactGA.pageview(window.location.pathname + window.location.hash + window.location.search)
// });
import axios from "axios";
import Logout from "./components/Logout/Logout";
import moment from "moment";

axios.interceptors.response.use(
    function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    },
    function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        // console.log(error.response);
        if (error.response?.status === 401) {
            sessionStorage.setItem("isSessionTimedOut", moment().format('x'));
            window.location.href = window.location.origin + "/#/signout";
            return false;
        } else return Promise.reject(error);
    },
);

const LoginComponent = lazy(() => import("./components/Login/Login"));
const PnGComponent = lazy(() => import("./components/Login/PnGCpmponent"));
const DomoComponent = lazy(() => import("./components/DomoComponent/DomoComponent"));
const SsoComponent = lazy(() => import("./components/Login/SsoComponent/SsoComponent"));
const MainContainer = lazy(() => import("./components/MainContainer/MainContainer"));

class App extends Component {
    constructor() {
        super();
        this.host = window.location.host;
        window.addEventListener("hashchange", (event) => {
            if (event.newURL.includes("azure-success")) {
                let x = event.newURL.split("?");
                let y = x[1].split("=");

                localStorage.setItem("jwt-token", y[1].split("&")[0]);
                localStorage.setItem("token", y[2].split("&")[0]);

                window.open("/#/home", "_self");
            }
        });
        this.iAmAlive = setInterval(() => {
            iAmLive();
        }, 5 * 60 * 1000);
    }

    componentDidMount(){
        ReactGA.set({ page: "commandcenter" });
	    ReactGA.pageview(window.location.pathname + window.location.hash + window.location.search)
    }

    render() {
        return (
            <Suspense fallback={<GlobalLoader />}>
                <Router >
                    <Switch>
                        <Route exact path="/" component={LoginComponent} />
                        <Route exact path="/pg" component={PnGComponent} />
                        <Route exact path="/domo" component={DomoComponent} />
                        <Route exact path="/sso_callback" component={SsoComponent} />
                        <Route exact path="/signout" component={Logout} />
                        <MainContainer />
                    </Switch>
                </Router>
                <ToastContainer
                    enableMultiContainer
                    containerId={"main-app"}
                    style={{ zIndex: "100000" }}
                    transition={Slide}
                    position="bottom-right"
                    type="default"
                    autoClose={7000}
                    hideProgressBar
                    newestOnTop={false}
                    closeOnClick
                    className="toastify-container skiptranslate"
                    toastClassName="toastify-toast"
                />
            </Suspense>
        );
    }

    componentWillUnmount() {
        clearInterval(this.iAmAlive)
        for (var i = 1; i < 99999; i++) {
            window.clearInterval(i);
        }
    }
}

export default App;
